import React from 'react';
import type { CollectionEntity } from 'src/web/collections/types';
import startCase from 'lodash/startCase';

type Props = Pick<CollectionEntity, 'type'>;

const TitleCell = ({ type }: Props) => <>{startCase(type)}</>;
export default TitleCell;
